const FOOTER_CONTACTS = Object.freeze([
  Object.freeze({ type: 'email', label: 'service@anovator.com', href: 'mailto:service@anovator.com' }),
  Object.freeze({ type: 'phone', label: '+86 199 4761 3805', href: 'tel:+8619947613805' })
])

const FOOTER_SOCIALS_BY_LANGUAGE = Object.freeze({
  EN: Object.freeze([
    Object.freeze({ id: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/anovator.global', icon: '/static/images/footer/facebook.svg' }),
    Object.freeze({ id: 'youtube', label: 'YouTube', href: 'https://www.youtube.com/@anovator', icon: '/static/images/footer/youtube.svg' }),
    Object.freeze({ id: 'x', label: 'X', href: null, icon: '/static/images/footer/x.svg' }),
    Object.freeze({ id: 'tiktok', label: 'TikTok', href: 'https://www.tiktok.com/@anovator_global', icon: '/static/images/footer/tiktok.svg' }),
    Object.freeze({ id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/anovator.global/', icon: '/static/images/footer/instagram.svg' }),
    Object.freeze({ id: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/company/anovator/', icon: '/static/images/footer/linkedin.svg' })
  ]),
  ZH: Object.freeze([
    Object.freeze({ id: 'wechat', label: '微信', href: null, icon: '/static/images/footer/wechat.svg', dialogTitle: '源诺医疗公众号', qrImage: '/static/images/footer/wechat-official-qr.jpeg' }),
    Object.freeze({ id: 'channels', label: '视频号', href: null, icon: '/static/images/footer/channels.svg', dialogTitle: '源诺医疗视频号', qrImage: '/static/images/footer/wechat-channels-qr.jpeg' }),
    Object.freeze({ id: 'xiaohongshu', label: '小红书', href: 'https://www.xiaohongshu.com/user/profile/62a04427000000001b02bca2', icon: '/static/images/footer/xiaohongshu.svg' }),
    Object.freeze({ id: 'douyin', label: '抖音', href: 'https://www.douyin.com/user/MS4wLjABAAAAHmaztD3FlOKQOpeK1XNPAwrzzFBwKyx_trEUJWSxEBc', icon: '/static/images/footer/douyin.svg' })
  ])
})

const FOOTER_SOCIALS = FOOTER_SOCIALS_BY_LANGUAGE.EN

function getFooterSocials(language) {
  return FOOTER_SOCIALS_BY_LANGUAGE[language] || FOOTER_SOCIALS_BY_LANGUAGE.EN
}

function shouldShowIcp(language) {
  return language === 'ZH'
}

const FOOTER_POLICIES = Object.freeze([
  Object.freeze({ id: 'privacy', label: 'Privacy Policy', to: '/privacy-policy' }),
  Object.freeze({ id: 'refund', label: 'Refund Policy', to: '/refund-policy' }),
  Object.freeze({ id: 'shipping', label: 'Shipping Policy', to: '/shipping-policy' }),
  Object.freeze({ id: 'terms', label: 'Terms Of Service', to: '/terms-of-service' }),
  Object.freeze({ id: 'data-subject', label: 'Data Subject Request Form', href: '/legal/GDPR-FORM-05-1-Data-Subject-Request-Form.pdf' }),
  Object.freeze({ id: 'cookie-settings', label: 'Cookie Settings', action: 'cookie-settings' })
])

module.exports = { FOOTER_CONTACTS, FOOTER_POLICIES, FOOTER_SOCIALS, getFooterSocials, shouldShowIcp }
